import { ISetUIAction, IUIState } from './ui.type';
import packageJson from '../../../package.json';

const initialState: IUIState = {
  allFeedbacks: [],
  version: packageJson.version,
};

const uiReducer = (state = initialState, action: ISetUIAction): IUIState => {
  switch (action.type) {
    case 'UI/ADD_FEEDBACK': {
      return {
        ...state,
        allFeedbacks: [...(state.allFeedbacks ?? []), action.payload],
      };
    }
    case 'UI/REMOVE_FEEDBACK': {
      return {
        ...state,
        allFeedbacks:
          state.allFeedbacks?.filter(x => x.id !== action.payload) ?? [],
      };
    }
    case 'UI/CLEAR_FEEDBACK': {
      return { ...state, allFeedbacks: [] };
    }
    case 'UI/SET_VISIBLE_GUIDE': {
      return { ...state, visibleGuide: action.payload };
    }
    case 'UI/SET_MAP_TYPE': {
      return { ...state, mapType: action.payload };
    }
    case 'UI/SET_THEME_MODE': {
      return { ...state, themeMode: action.payload };
    }
    case 'UI/SET_VERSION': {
      return { ...state, version: action.payload };
    }
    case 'AUTH/LOGOUT': {
      return initialState;
    }
    default: {
      return state;
    }
  }
};

export default uiReducer;
